import { HelpCircle } from "lucide-react";

export const EmailBlacklistsSeverity = () => {
  const questions = [
    {
      q: "Which list is it",
      a: "The only meaningful split is Spamhaus versus everything else. A Spamhaus listing is consulted globally and produces hard delivery failures. Most other lists have narrow reach and produce a scoring nudge inside specific gateways.",
    },
    {
      q: "Did placement or reply rates actually move",
      a: "Compare the days before and after the listing. If inbox placement, reply rate and bounce rate are flat, the listing is costing you nothing at the major providers, and the alert is louder than the impact.",
    },
    {
      q: "What caused it",
      a: "A behavioral cause means the underlying list quality or content problem is real and must be fixed. If you only request removal without fixing the cause, any remediation is temporary and the listing returns.",
    },
  ];

  const rows = [
    {
      list: "Spamhaus SBL and DBL",
      severity: "Critical",
      reach: "Consulted globally",
      tone: "text-destructive bg-destructive/10",
    },
    {
      list: "SURBL and URIBL",
      severity: "Advisory",
      reach: "Affects gateway filtered recipients only",
      tone: "text-warning bg-warning/10",
    },
    {
      list: "SpamCop, Barracuda",
      severity: "Advisory",
      reach: "Limited reach",
      tone: "text-warning bg-warning/10",
    },
    {
      list: "Abandoned legacy lists",
      severity: "Ignorable",
      reach: "Consulted by almost nobody",
      tone: "text-muted-foreground bg-muted",
    },
  ];

  return (
    <section className="py-10 sm:py-12">
      <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-3 text-center">
        How to read a listing
      </h2>
      <p className="text-muted-foreground text-center max-w-2xl mx-auto mb-8">
        Three questions turn a blacklist alert from an alarm into a diagnosis.
      </p>

      <div className="grid gap-4 sm:grid-cols-3">
        {questions.map((item, index) => (
          <div key={index} className="bg-card rounded-xl border border-border p-5">
            <div className="flex items-center gap-2 mb-2">
              <HelpCircle className="w-4 h-4 text-primary" />
              <h3 className="font-semibold text-foreground text-sm">{item.q}</h3>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">{item.a}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 overflow-x-auto">
        <table className="w-full text-left border border-border rounded-xl overflow-hidden">
          <caption className="sr-only">Blacklist severity by reach</caption>
          <thead className="bg-muted/50">
            <tr>
              <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground">List</th>
              <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground">Severity</th>
              <th scope="col" className="px-4 py-3 text-xs font-semibold text-foreground">Reach</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index} className="border-t border-border">
                <td className="px-4 py-3 text-sm font-medium text-foreground">{row.list}</td>
                <td className="px-4 py-3">
                  <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${row.tone}`}>
                    {row.severity}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm text-muted-foreground">{row.reach}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};